import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { Loader2, MessageSquare, ArrowLeft } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function TermsOfServicePage() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/public/legal`)
      .then((r) => r.json())
      .then((d) => setContent(d))
      .catch(() => setContent({ terms_of_service_html: '<p>Não foi possível carregar os termos.</p>' }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <Seo
        title="Termos de Uso | Watizap"
        description="Conheça os Termos de Uso da plataforma Watizap para envio de mensagens em massa pelo WhatsApp."
        path="/termos-de-uso"
      />
      <header className="border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-back-home">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center">
              <MessageSquare className="w-5 h-5 text-white" />
            </div>
            <span className="text-lg font-bold">Watizap</span>
          </Link>
          <Link
            to="/"
            className="text-sm text-slate-600 dark:text-slate-300 hover:text-teal-600 dark:hover:text-teal-400 inline-flex items-center gap-1"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-4 h-4" /> Voltar
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <Loader2 className="w-6 h-6 animate-spin text-teal-600" />
          </div>
        ) : (
          <article
            className="bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 p-8 sm:p-12 legal-content"
            data-testid="terms-of-service-content"
            dangerouslySetInnerHTML={{ __html: content?.terms_of_service_html || '' }}
          />
        )}
      </main>
    </div>
  );
}
